import { useNavigate } from 'react-router-dom'

import { Card } from '@/modules/shared/components/ui/card'
import { Layout } from '@/modules/shared/layouts/layout'

import { useDocsList } from '../hooks/use-docs-list.hook'
import { DocListInterface } from '../interfaces/doc-list.interface'

export function DocListContainer() {
  const navigate = useNavigate()
  const docsListHook = useDocsList()
  return (
    <Layout pageTitle="Central de ajuda" handleGoBack={() => navigate('/')}>
      <Card className="col-span-1 p-5 gap-2">
        <DocListInterface {...docsListHook} />
      </Card>
    </Layout>
  )
}
